
function initEcSliders() {
  document.querySelectorAll('[data-slider-id]').forEach(sliderElement => {
    const sliderId = sliderElement.id;
    if (!sliderId || sliderElement.dataset.swiperInitialized) return;

    const swiperContainer = sliderElement.querySelector('.ec-slider-swiper');
    if (!swiperContainer) return;

    const computedStyle = window.getComputedStyle(sliderElement);
    const productsPerPageRaw = computedStyle.getPropertyValue('--products-per-page').trim();
    const gapRaw = computedStyle.getPropertyValue('--gap').trim();
    const gapMobileRaw = computedStyle.getPropertyValue('--gap-mobile').trim();
    
    const productsPerPage = productsPerPageRaw ? parseInt(productsPerPageRaw) : 4;
    const gap = gapRaw ? parseInt(gapRaw.replace('px', '')) : 20;
    const gapMobile = gapMobileRaw ? parseInt(gapMobileRaw.replace('px', '')) : gap;

    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: gap,
      slidesPerGroup: productsPerPage,
      loop: false,
      speed: 600,
      navigation: {
        nextEl: sliderElement.querySelector('.swiper-button-next'),
        prevEl: sliderElement.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: sliderElement.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<button class="' + className + '" aria-label="Ir para página ' + (index + 1) + '"></button>';
        },
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          slidesPerGroup: productsPerPage,
          spaceBetween: gap,
        },
        0: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: gapMobile,
        }
      },
      on: {
        init: function() {
          sliderElement.dataset.swiperInitialized = 'true';
        }
      }
    });

    sliderElement.swiperInstance = swiper;
  });
}

function waitForSwiper() {
  if (typeof Swiper !== 'undefined') {
    initEcSliders();
  } else {
    setTimeout(waitForSwiper, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForSwiper);
} else {
  waitForSwiper();
}
